// Page module: the prematch screens (matches#edit).

global.preMatch = {
  data: {
    home: {
      defaultColor: { bg: '#007bff', text: '#ffffff' }
    },
    away: {
      defaultColor: { bg: '#dc3545', text: '#ffffff' }
    },
    // The coach reopens the whole bench and the roster with it, so this one is its own
    // sentence. It said "ponovno vnesti celotno klop" — nothing is re-entered and nothing
    // is reset: the roster and the bench simply unlock with everything still in them.
    resetCoachText: "<b>Spremeni ekipo ali klop?</b><br><br>Postava in klop se <b>odkleneta</b> za urejanje in vsi vpisani podatki ostanejo. Ker se prijavna lista spremeni, bo <b>trener moral znova podpisati</b>.",

    // Who is asked to sign on THIS screen: the four assistant referees. The three
    // referees and the technical commissioner are in SignatureBook::PREMATCH_SLOTS but
    // sign the finished scoresheet, not the entry lists — _referee.html.haml collects no
    // signature at all — and the statisticians never sign. Telling any of them that a
    // signature will have to be collected again is simply untrue.
    signsHere: ['scorekeeper', 'scorekeeper_assistant', 'timekeeper', 'timekeeper_assistant'],

    resetWho: {
      scorekeeper: 'zapisnikarja',
      scorekeeper_assistant: 'pom. zapisnikarja',
      timekeeper: 'časomerilca',
      timekeeper_assistant: 'merilca napada',
      referee1: '1. sodnika',
      referee2: '2. sodnika',
      referee3: '3. sodnika',
      commissioner: 'teh. komisarja',
      statistician1: 'statistika 1',
      statistician2: 'statistika 2'
    }
  },
  // What reopening a person actually does. It used to say "Do sedaj vnešeni podatki o
  // njem bodo ponastavljeni" for all ten roles — two things wrong with that: nothing is
  // wiped any more (resetPersonAction keeps the licence number and the name, so
  // correcting somebody else's entry no longer costs a re-check), and only the assistant
  // referees are asked to sign here.
  resetBodyText: function(role) {
    if(role === 'coach') return preMatch.data.resetCoachText;

    var who = preMatch.data.resetWho[role];
    if(!who) return "<b>Ste prepričani?</b><br><br>Polja se bodo odklenila za urejanje.";

    var body = "<b>Spremeni " + who + "?</b><br><br>";
    body += "Vpisani podatki ostanejo, polja se le odklenejo za urejanje.";
    if(preMatch.data.signsHere.indexOf(role) >= 0) {
      body += " Potreben bo nov podpis.";
    }
    return body;
  },
  // What a confirmation confirms. Every one of the ten said "Ali ste prepričani o
  // potrditvi?", which names neither the person nor what happens — and for somebody who
  // is deliberately absent it asked about nothing at all.
  confirmPersonText: function(side, role) {
    var who = preMatch.data.resetWho[role] || 'osebo';

    if(context.isPersonMissing(side, role)) {
      return "<b>Potrdi, da " + who + " ni na tekmi?</b><br><br>Vpis se zaklene. "
             + "Za spremembo klikni <b>Spremeni</b>.";
    }

    var name = (side === 'referees') ? context.officialName(role) : context.personName(side, role);
    var body = "<b>Potrdi " + who + ": " + name + "?</b><br><br>";
    body += "Vpis se zaklene in vpisani podatki ostanejo. Za spremembo klikni <b>Spremeni</b>.";
    if(preMatch.data.signsHere.indexOf(role) >= 0) {
      body += " Takoj za tem zberi podpis.";
    }
    return body;
  },
  init: function(urls, settings, competitionId, isCustom, matchId) {
    // The commissioner's own door to the report: a link mailed to them, the same
    // one the post-match screen sends and the same uuid-authenticated address —
    // one report, two doors. Offered here, before the match, because that is when
    // the commissioner is standing at the table and when the report becomes
    // fillable (the other officials now, the reason for a technical as it happens).
    $('#report-link-btn').on('click', function() {
      var url = $(this).data('url');
      var known = $(this).data('emails') || [];

      var body = "<p>Komisar dobi povezavo do poročila na svoj e-naslov — izpolnjuje ga lahko že med tekmo, zaključi pa po koncu.</p>";
      if(known.length) {
        body += "<p class='eyebrow mb-1'>Znani naslovi</p><p class='report-invite__known'>";
        for(var i = 0; i < known.length; i++) {
          body += "<button type='button' class='btn btn-sm btn-outline-secondary mr-1 mb-1 js-use-email' data-email='" + known[i][1] + "'>"
                + known[i][0] + ": " + known[i][1] + "</button>";
        }
        body += "</p>";
      }
      body += "<label class='field field--wide'><span class='eyebrow'>E-naslov</span>"
            + "<input type='email' class='form-control' id='report-invite-email' placeholder='ime@primer.si'></label>"
            + "<p class='mt-3 mb-0'><button type='button' class='btn btn-primary' id='report-invite-send'>Pošlji povezavo</button></p>";

      alerts.show({ title: 'Poročilo za komisarja', type: 'info', body: body });
    });

    // the shortcuts only fill the field — sending stays one deliberate click
    $(document).on('click', '.js-use-email', function() {
      $('#report-invite-email').val($(this).data('email')).focus();
    });

    $(document).on('click', '#report-invite-send', function() {
      var $btn = $(this);
      var email = ($('#report-invite-email').val() || '').trim();
      if(!email) return;

      $btn.prop('disabled', true).text('Pošiljam…');
      $.ajax($('#report-link-btn').data('url'), {
        method: 'GET',
        data: { email: email },
        timeout: 10000,
        success: function() {
          $btn.closest('.modal').modal('hide');
          alerts.info('Povezava poslana', "<p>Poročilo je na poti na <b>" + email + "</b>.</p>");
        },
        error: function(err, status, msg) {
          console.error(status, msg, err);
          $btn.prop('disabled', false).text('Pošlji povezavo');
          alerts.warning("<p>Povezave ni bilo mogoče poslati. Poskusi znova.</p>");
        }
      });
    });

    preMatch.data.urls = urls;
    preMatch.data.isCustom = isCustom;
    preMatch.data.competition_id = competitionId;
    preMatch.data.match_id = matchId;
    context = {
      loaded: false,
      home: {
        color: preMatch.data.home.defaultColor,
        coach: {},
        assistant: {},
        representative: {},
        players: []
      },
      away: {
        color: preMatch.data.away.defaultColor,
        coach: {},
        assistant: {},
        representative: {},
        players: []
      },
      // The roster flags arrive from the server as the STRINGS "true"/"false"
      // and only become real booleans once the keeper touches a checkbox. In
      // JS "false" is truthy, so reading them raw counted (and ticked) every
      // player on any saved match — the footer said 12/12/12 instead of 12/5/1.
      isTrue: function(value) {
        return value === true || value === 'true';
      },
      numberOfPlayerForField(side, fn) {
        var n = 0;
        for(var p of (this[side].players || [])) {
          if(this.isTrue(p[fn])) {
            n++;
          }
        }
        return n;
      },
      numberOfPlayers: function(side) {
        return this.numberOfPlayerForField(side, 'in_lineup');
      },
      numberOfPlayersInStarting5: function(side) {
        return this.numberOfPlayerForField(side, 'is_starting');
      },
      numberOfPlayersInA: function(side) {
        return this.numberOfPlayerForField(side, 'in_a');
      },
      numberOfPlayersInB: function(side) {
        return this.numberOfPlayerForField(side, 'in_b');
      },
      numberOfCaptains: function(side) {
        return this.numberOfPlayerForField(side, 'is_captain');
      },
      hasOfficials: function() {
        return !!context.referees;
      },
      getOfficialFromApi: function(side, role) {
        if(this[side][role]) {
          this[side][role].searching = true;
          refreshContext();
        }
        // preMatch.loadReferees(role);
      },
      isOfficial: function(type) {
        return this.hasOfficials() && !!this.referees[type]; 
      },
      // No trailing colon: this is the eyebrow over an official's card now, not a run-in
      // heading before their name.
      officialLabel: function(type) {
        if(type === 'referee1') {
          return "1. sodnik";
        } else if(type === 'referee2') {
          return "2. sodnik";
        } else if(type === 'referee3') {
          return "3. sodnik";
        } else if(type === 'commissioner') {
          return "Teh. komisar";
        } else {
          return "";
        }
      },
      official: function(type) {
        return this.isOfficial(type) && this.referees[type];
      },
      officialNameApi: function(type) {
        var off = this.official(type);
        if(off && off.fms_id) {
          return this.officialName(type);
        } else {
          return "Uradne osebe ni bilo mogoče pridobiti avtomatsko. Vnesite jo ročno.";
        }
      },
      // Third copy of this getter (the live sheet and the report have their own) and
      // it had the same hole: `off` existing does not mean it has a name. An official
      // picked "z licenco" whose lookup has not answered — or answered with nothing —
      // has a status and no first_name/last_name, and this returned
      // `undefined + " " + undefined`. It shows up in the confirm dialog above as
      // "Potrdi 1. sodnik: undefined undefined?", which is where it is worst: that is
      // the sentence somebody is agreeing to.
      // Officials' name fields are bound the way the roster's are — a getter that
      // always returns a string, plus an explicit writer (playerFirstName /
      // onPlayerFirstNameChange). They must NOT be a keypath `data-bind`.
      //
      // A keypath binding is two-way. When the context value is undefined — a 3rd
      // referee or a commissioner FMS did not send, or a licence lookup that has not
      // answered — Twine does `node.value = undefined`, and the DOM turns that into
      // the STRING "undefined". Twine then reads the node back: on a keyup, and on
      // every rebind, because its bind-time writeback fires whenever the context value
      // is nullish and the node is not.
      //
      // Measured in the browser: context {status:'API'} -> the three inputs all read
      // "undefined" -> one keyup wrote first_name:"undefined" -> a rebind wrote
      // first_name, last_name AND city. It reaches the printed scoresheet, where
      // short_name sees a present? string and renders "UNDEFINED U. (undefined)".
      // Through the global `context`, not `this`, exactly as hasOfficials() above
      // does. Twine evaluates a binding by calling the function with its own
      // receiver, so `this` is not reliably the context — and during the first bind
      // it can be an object that has no `referees` at all, which threw
      // "Cannot read properties of undefined (reading 'referee1')" on prematch.
      officialField: function(type, field) {
        var refs = (typeof context !== 'undefined' && context.referees) || {};
        var o = refs[type];
        return (o && o[field]) || '';
      },
      officialFirstName: function(type) { return this.officialField(type, 'first_name'); },
      officialLastName:  function(type) { return this.officialField(type, 'last_name'); },
      officialCity:      function(type) { return this.officialField(type, 'city'); },
      // Writes only what was typed. The entry is created here rather than by Twine,
      // so an official nobody touched stays absent instead of becoming an empty one.
      onOfficialFieldChange: function(el, event, type, field) {
        if(!context.referees) context.referees = {};
        if(!context.referees[type]) context.referees[type] = {};

        context.referees[type][field] = el.value;
      },
      hasOfficialName: function(type) {
        var off = this.official(type);
        return !!(off && off.first_name && off.last_name);
      },
      officialName: function(type) {
        if(!this.hasOfficialName(type)) return "";

        var off = this.official(type);
        var s = off.first_name + " " + off.last_name;
        if(off.city) s += " (" + off.city + ")";
        return s;
      },
      json: function() {
        return JSON.stringify(this);
      },
      playerPhotos: function(side) {
        var photos = [];
        for(let p of this[side].players) {
          if(p && p.photo_url) photos.push(p.photo_url);
        }
        return photos;
      },
      hasPlayerPhoto: function(side, index) {
        var p = this.player(side, index);
        return p && p.photo_url;
      },
      showPlayerPhoto: function(side, index) {
        var p = this.player(side, index);
        alerts.info(this.playerName(side, index), "<p class='text-center'><img style='max-width: 100%;' src='"+p.photo_url+"' /></p>");
      },
      hasPlayers: function(side) {
        return !!this[side].players;
      },
      isPlayer: function(side, index) {
        if(!(this.hasPlayers(side) && this[side].players.length > index)) return false;
        return !this.isGhostPlayer(side, index);
      },
      // A slot nobody entered, left behind by the name inputs' old two-way binding
      // (see onPlayerFirstNameChange). They came in two flavours — "UNDEFINED
      // undefined" where the DOM had stringified an `undefined`, and blank where it
      // had not — and they rendered as rows with no licence, no number and nothing
      // to act on. Match#drop_ghost_players throws them out on save; this keeps them
      // off the screen and off every getter that goes through player().
      //
      // The fms_id is what makes this safe. EVERY player the app itself puts in a
      // roster has one, including the blank placeholder rows of a manual match
      // (TeamsController numbers them 10000+), and those rows must keep showing —
      // they are what the keeper types into. A slot with no fms_id at all was never
      // put there by anything; and if anything was entered into it, it stays.
      isGhostPlayer: function(side, index) {
        var p = this[side].players[index];
        if(!p || p.fms_id) return false;
        var blank = function(v) { return !v || v === 'undefined'; };
        if(!blank(p.first_name) || !blank(p.last_name) || !blank(p.number)) return false;
        return !this.isTrue(p.in_lineup) && !this.isTrue(p.is_starting) &&
               !this.isTrue(p.is_captain) && !this.isTrue(p.in_a) && !this.isTrue(p.in_b);
      },
      player: function(side, index) {
        return this.isPlayer(side, index) && this[side].players[index];
      },
      playerLicenseNumber: function(side, index) {
        var p = this.player(side, index);
        return p ? p.license_number : '';
      },
      playerNumber: function(side, index) {
        var p = this.player(side, index);
        return p ? p.number : '';
      },
      playerTeam: function(side, index) {
        var p = this.player(side, index);
        return p ? p.team : '';
      },
      playerName: function(side, index) {
        var p = this.player(side, index);
        return p ? p.last_name.toUpperCase() + " " + p.first_name : '';
      },
      playerFirstName: function(side, index) {
        var p = this.player(side, index);
        return p ? p.first_name : '';
      },
      playerLastName: function(side, index) {
        var p = this.player(side, index);
        return p ? p.last_name : '';
      },
      isPlayerInLineup: function(side, index) {
        var p = this.player(side, index);
        return p && this.isTrue(p.in_lineup);
      },
      isPlayerInA: function(side, index) {
        var p = this.player(side, index);
        return p && this.isTrue(p.in_a);
      },
      isPlayerInB: function(side, index) {
        var p = this.player(side, index);
        return p && this.isTrue(p.in_b);
      },
      isPlayerStarting: function(side, index) {
        var p = this.player(side, index);
        return p && this.isTrue(p.is_starting);
      },
      isPlayerCaptain: function(side, index) {
        var p = this.player(side, index);
        return p && this.isTrue(p.is_captain) && index+"";
      },
      onPlayerChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) {
          p.number = el.value;
          refreshContext();
        }
      },
      onPlayerInAChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) {
          p.in_a = el.checked;
          p.in_lineup = el.checked;
          refreshContext();
        }
      },
      onPlayerInBChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) {
          p.in_b = el.checked;
          p.in_lineup = el.checked;
          refreshContext();
        }
      },
      // The names go through a handler like every other field in the row, rather
      // than binding straight to home.players[3].first_name.
      //
      // A keypath binding is TWO-WAY, and twine writes it back for all 51 rendered
      // rows whether a player is there or not — creating the slot if it has to. That
      // is where the roster grew slots nobody entered: rows past the end of the list
      // wrote themselves into it. A handler cannot: it asks for the player first, and
      // there is nobody at that index to name.
      //
      // On `input`, not `change`, so typing still lands immediately — a name typed and
      // then confirmed without leaving the field must be saved.
      onPlayerFirstNameChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) p.first_name = el.value;
      },
      onPlayerLastNameChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) p.last_name = el.value;
      },
      onPlayerInLineupChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) {
          p.in_lineup = el.checked;
          refreshContext();
        }
      },
      onPlayerIsStartingChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) {
          p.is_starting = el.checked;
          refreshContext();
        }
      },
      onPlayerIsCaptainChange: function(el, event, side, index) {
        var p = this.player(side, index);
        if(p) {
          for(let pl of this[side].players) {
            pl.is_captain = false;
          }
          p.is_captain = el.checked;
          if(this.isTrue(p.is_captain) && this.isPersonMissing(side, 'coach')) {
            this.setCaptainAsCoach(side);
          }
          refreshContext();
        }
      },
      resetJerseyNumbers: function(side) {
        var con = this;
        var callback = function() {
          for(var p of con[side].players) {
            p.number = "";
          }
          refreshContext();
        };
        // it erases, so it says so — "ponastaviti" promised something gentler than what
        // the callback does
        alerts.confirmation({ title: "Potrditev", body: "<p><b>Izbriši številke dresov?</b></p><p>Vsem igralcem se izbriše številka dresa. Igralci in vse ostalo ostane.</p>", yesCallback: callback });
      },
      // One of the "Pogosto s teboj" chips. It fills the form and then runs exactly
      // what typing would run — there is no second validation path, which is how the
      // licence check, the confirmation and the signature stay untouched by this
      // feature.
      //
      // The number on the chip is THIS season's, resolved by name in
      // RecentColleagues; numbers are reissued every season, so the one sitting in
      // the old match is dead and is never handed back.
      pickColleague: function(side, role, index) {
        var list = (preMatch.data.colleagues || {})[role] || [];
        var colleague = list[index];
        if(!colleague) return;

        this.fillPerson(side, role, colleague);
      },
      // Picking a person is a decision, so it settles the person: the check runs,
      // and if it comes back clean the role is confirmed and the signature is
      // requested — the same two steps the keeper would have clicked, in the same
      // order, with the same rules. A check that does not come back clean leaves
      // the form open, because there is then something to look at.
      fillPerson: function(side, role, colleague) {
        if(colleague.license_number) {
          preMatch.selectPersonStatus(side, role, 'with_license');
          setContext(side+"."+role+".license_number", colleague.license_number);
          // the name is left to the licence check to fill, so what the keeper reads
          // is what the licensing system says, not what an old match remembered
          setContext(side+"."+role+".first_name", '');
          setContext(side+"."+role+".last_name", '');
          preMatch.fillPinField(side, role, colleague.license_number);
          preMatch.data.confirmAfterCheck = side + "." + role;
          this.checkLicenseNumber(side, role);
        } else {
          // no live licence: the same path a keeper takes for somebody unlicensed
          preMatch.selectPersonStatus(side, role, 'without_license');
          setContext(side+"."+role+".license_number", '');
          setContext(side+"."+role+".license_status", '');
          setContext(side+"."+role+".license_status_code", '');
          setContext(side+"."+role+".first_name", colleague.first_name);
          setContext(side+"."+role+".last_name", colleague.last_name);
          // nothing to check, so the decision is already made
          preMatch.settlePerson(side, role);
        }
      },
      // Switching to "IMA licenco" must not carry a hand-typed name across. The name
      // in that branch is a CLAIM that this person holds this licence, and the only
      // thing entitled to write it is the check itself — otherwise a keeper types a
      // name under "NIMA licence", switches, and confirms somebody as licensed
      // without a licence ever being looked at.
      //
      // A name that DID come from a check (checked_number is set) is left alone, so
      // going away and back does not throw away a good answer.
      // A verdict belongs to the number it was given. Edit the number after a good
      // check and the green "Licenca je v redu" used to stay put under a number
      // nobody had looked at — no outage required.
      isLicenseChecked: function(side, role) {
        var person = this[side][role];
        return !!(person && person.checked_number && person.checked_number == person.license_number);
      },
      onPersonLicenseRadioClick: function(side, role) {
        var person = this[side][role] || {};
        if(person.checked_number) return;

        // kept out of the context on purpose: the client PUTs the whole settings
        // document, and this is scratch, not part of the match
        setData(side+"."+role+".typed",
                { first_name: person.first_name, last_name: person.last_name },
                preMatch.data);
        setContext(side+"."+role+".first_name", "");
        setContext(side+"."+role+".last_name", "");
        setContext(side+"."+role+".license_status", "");
        setContext(side+"."+role+".license_status_code", "");
      },
      checkLicenseNumber: function(side, role) {
        // A confirmed person is never looked up again. The check is not read-only:
        // it overwrites first_name and last_name with whatever the register says,
        // and on NO_LICENSE it moves the person to "NIMA licence" and hands back
        // what was typed before. Behind a confirmation — and for a coach, behind a
        // signature — that rewrites what somebody already agreed to.
        //
        // The button that calls this is inside the unconfirmed branch of
        // _person_with_license, so today nothing can reach it. This is the guard
        // that keeps it that way, because the damage is silent and lands on a
        // document that has been signed.
        if(this.isPersonConfirmed(side, role)) return;

        var lic = this[side][role].license_number;
        if(side == 'home' || side == 'away') {
          preMatch.validateCoach(side, role, lic);
        } else if(side == 'assistant_referees') {
          preMatch.validateAssistantReferee(side, role, lic);
        } else if(side == 'statisticians') {
          preMatch.validateStatistician(side, role, lic);
        }
      },
      licenseNumberText: function(side, role) {
        var lic = ((this[side] || {})[role] || {}).license_number;
        if(lic) {
          return "("+lic+")";
        } else {
          return "";
        }
      },
      canConfirmPerson: function(side, role) {
        return ((this[side] || {})[role] || {}).status == 'missing' || this.hasPersonName(side, role);
      },
      confirmPerson: function(side, role) {
        if(this.canConfirmPerson(side, role)) {        
          var con = this;
          var callback = function() {        
            setContext(side + "." + role + ".confirmed", "confirmed");
            con.save(function() {
              if(side != 'referees' && !con.isPersonMissing(side, role)) {
                con.showQrCode(side, role); 
              } 
            });
          };
          alerts.confirmation({ title: "Potrditev", body: preMatch.confirmPersonText(side, role), yesCallback: callback });
        }
      },
      canConfirmBench: function(side) {
        for(role of ['coach', 'assistant', 'representative']) {
          if(!this.canConfirmPerson(side, role)) return false;
        }
        return this.rosterProblems(side).length === 0;
      },
      // What still has to be right before the roster may be locked. The number
      // of starters is deliberately NOT here — that is the coach's pick, on
      // their own screen. Everything else is: none of it can be fixed from the
      // coach's screen, and Match#settings_errors would refuse the sheet
      // anyway, so locking would strand the keeper until a reset.
      rosterProblems: function(side) {
        var problems = [];
        var all = this[side].players || [];
        var lineup = [];
        for(var player of all) {
          if(this.isTrue(player.in_lineup) || this.isTrue(player.in_a) || this.isTrue(player.in_b)) {
            lineup.push(player);
          }
        }

        // Said first, because with an empty roster every other rule passes vacuously
        // and the keeper was told about the captain instead of about the empty sheet.
        //
        // Five, not one: five on the floor is the game, and Match#settings_errors has
        // always refused fewer. Asking for one here let a keeper confirm the bench and
        // collect the coach's signature, and only be turned back at the door to the
        // scoresheet — with the roster locked behind them. Same sentence, same number,
        // said at the point where it can still be fixed.
        if(lineup.length < 5) {
          problems.push('V ekipi za tekmo mora biti vsaj 5 igralcev');
        }

        var captains = [];
        for(var candidate of all) {
          if(this.isTrue(candidate.is_captain)) captains.push(candidate);
        }
        if(captains.length !== 1) {
          problems.push('Ekipa mora imeti enega kapetana');
        } else if(lineup.indexOf(captains[0]) < 0) {
          problems.push('Kapetan mora biti na tekmi');
        }

        var numbers = [];
        var missing = false, duplicate = false;
        for(var listed of lineup) {
          var number = listed.number == null ? '' : String(listed.number).trim();
          if(number === '') {
            missing = true;
          } else if(numbers.indexOf(number) >= 0) {
            duplicate = true;
          } else {
            numbers.push(number);
          }
        }
        if(missing) problems.push('Vsi igralci na tekmi morajo imeti številko dresa');
        if(duplicate) problems.push('Vsak igralec mora imeti svojo številko dresa');

        return problems;
      },
      // shown on the disabled confirm button, so it is clear what is missing
      benchProblemsText: function(side) {
        var problems = this.rosterProblems(side);
        if(problems.length === 0) return 'Potrdi klop in ekipo ter zberi podpis trenerja';

        // T-form, like the rest of the keeper's screens — this one said "popravite".
        return 'Najprej popravi: ' + problems.join('; ');
      },
      // Locked by confirming the bench — the same action that asks the coach to
      // sign — and unlocked only by resetting it, which drops the coach's
      // signature so they have to sign again. Jersey colours stay editable.
      isRosterLocked: function(side) {
        return this.isPersonConfirmed(side, 'coach');
      },
      // The tag on a locked roster card, and it is about the SIGNATURE, not
      // about the lock.
      //
      // Locking follows from confirming the bench, and the coach signs after
      // that — on a phone, in their own time, and sometimes not at all: they may
      // read the brief, see something wrong, and press "Nekaj ni v redu". The
      // tag said PODPISANO from the moment the bench was confirmed, so it
      // claimed a signature that did not exist and, after a refusal, one that
      // had been declined.
      //
      // Three states, because a team may also turn up without a coach: then
      // there is no signature to wait for and the card is simply settled.
      isRosterAwaitingSignature: function(side) {
        return this.isRosterLocked(side) && this.shouldPersonSign(side, 'coach');
      },
      rosterLockText: function(side) {
        if(this.hasPersonSigned(side, 'coach')) return "Podpisano";
        if(this.shouldPersonSign(side, 'coach')) return "Čaka na podpis";

        return "Potrjeno";
      },
      confirmBenchAndSignCoach: function(side) {
        if(this.canConfirmBench(side)) {
          var con = this;
          var callback = function() {        
            for(role of ["coach", "assistant", "representative"]) {
              setContext(side + "." + role + ".confirmed", "confirmed");
            }
            con.save( function() {
              var role = 'coach';
              if(!con.isPersonMissing(side, role)) {
                con.showQrCode(side, role); 
              } 
            });
          };
          alerts.confirmation({
            title: "Potrditev",
            body: "<p><b>Potrdi ekipo in klop?</b></p>"
                  + "<p>Zakleneta se <b>klop in ekipa</b> — številke dresov, igralci na tekmi, "
                  + preMatch.data.startingGroupLabel + " in kapetan. Odprte ostanejo le barve dresov. "
                  + "Trener nato na telefonu izbere " + preMatch.data.startingGroupLabelAcc + " in podpiše.</p>"
                  + "<p class='mb-0'>Za popravke klikni <b>Spremeni ekipo ali klop</b>; trener se bo moral "
                  + "<b>znova podpisati</b>.</p>",
            yesCallback: callback
          });
 
        }
      },
      // Null-safe slot access. Any of the accessors below can be evaluated by a
      // binding BEFORE loadSettings has answered, when the context has no
      // referees/assistant_referees/home/away yet — `this[side][role]` then
      // threw "Cannot read properties of undefined (reading 'referee1')" on a
      // slow load (a rare, timing-dependent console error on prematch).
      person: function(side, role) {
        return (this[side] || {})[role];
      },
      isPersonConfirmed: function(side, role) {
        var p = this.person(side, role);
        return p && p.confirmed == 'confirmed';
      },
      hasPersonLicense: function(side, role) {
        var p = this.person(side, role);
        return p && p.status === "with_license";
      },
      isPersonWithoutLicense: function(side, role) {
        var p = this.person(side, role);
        return p && p.status === "without_license";
      },
      isPersonMissing: function(side, role) {
        var p = this.person(side, role);
        return p && p.status === "missing";
      },
      isPersonFromApi: function(side, role) {
        var p = this.person(side, role);
        return p && p.status === "API";
      },
      isPersonFromApiSearching: function(side, role) {
        var p = this.person(side, role);
        return p && p.status === "API" && p.searching;
      },
      isPersonFromManualCustom: function(side, role) {
        var p = this.person(side, role);
        return p && p.status === "MANUAL_CUSTOM";
      },
      syncField: function(field, value) {
        setContext(field, value);
      },
      hasPersonName: function(side, role) {
        var p = this.person(side, role);
        return p && p.first_name && p.last_name;
      },
      hasPersonCity: function(side, role) {
        var p = this.person(side, role);
        return p && p.city;
      },
      personName: function(side, role) {
        if(this.hasPersonName(side, role)) {
          var p = this.person(side, role);
          return p.first_name + " " + p.last_name;
        } else {
          return "";
        }
      },
      onPersonMissingRadioClick: function(side, role) {
        setTimeout(function() {
          if(role == 'coach') {
            this.setCaptainAsCoach(side);  
          }
        }.bind(this), 100);
      },
      resetPersonAction: function(side, role) {
        // Only unlock: keep the licence number and the name that were already
        // entered. Wiping them meant retyping and re-checking a licence just to
        // correct something else.
        var person = this[side][role];
        if(!person) return;

        delete person.confirmed;
        delete person.sig;
      },
      resetPerson: function(side, role) {
        var con = this;
        var yesCallback = function() {
          con.resetPersonAction(side, role);
          if(role === 'coach') {
            con.resetPersonAction(side, "assistant");
            con.resetPersonAction(side, "representative");
          }
          refreshContext();
        };
        alerts.confirmation({ title: 'Potrditev', body: preMatch.resetBodyText(role), yesCallback: yesCallback });
      },
      captain: function(side) {
        for(var p of this[side].players) {
          if(this.isTrue(p.is_captain)) return p;
        }
        return null;
      },
      // FMS says whether a player may be put on this match's sheet at all — the
      // rest rules (games per day, per week, per season). Absent means yes: the
      // field is new, and a missing answer must not bar anybody.
      canPlayerPlay: function(side, index) {
        var p = this.player(side, index);
        return !p || p.can_play !== false;
      },
      cannotPlayText: function(side, index) {
        var p = this.player(side, index);
        return (p && p.cannot_play_text) || '';
      },
      // Out of the roster table and into the list of those who may not play.
      //
      // On a match still being set up that is everyone FMS blocks, full stop —
      // clearBlockedFromSheet takes any of them off the sheet first, so there is
      // never a blocked player counted in the line-up with no row to untick.
      //
      // A FINISHED match is a record, not a form: it was played with the roster it
      // had, and somebody blocked today may have been perfectly eligible then. So
      // anyone already on that sheet stays in the table, where the sheet says he
      // played.
      isPlayerBlocked: function(side, index) {
        if(this.canPlayerPlay(side, index)) return false;
        if(!preMatch.data.matchFinished) return true;

        var p = this.player(side, index);
        return !(p && (this.isTrue(p.in_lineup) || this.isTrue(p.in_a) || this.isTrue(p.in_b)));
      },
      // A blocked player cannot be on the sheet of a match that has not been played.
      // Leaving him there would refuse the roster (Match#settings_errors) from a row
      // the keeper can no longer see, so he comes off — and the reason he came off is
      // on screen, in the list below the table.
      //
      // Never on a finished match, and never on a locked roster: the lock means the
      // coach has signed for exactly this list, and loadPlayers does not refresh it.
      clearBlockedFromSheet: function(side) {
        if(preMatch.data.matchFinished || this.isRosterLocked(side)) return false;

        var players = (this[side] && this[side].players) || [];
        var changed = false;
        for(var i = 0; i < players.length; i++) {
          var p = players[i];
          if(this.canPlayerPlay(side, i)) continue;
          if(!(this.isTrue(p.in_lineup) || this.isTrue(p.in_a) || this.isTrue(p.in_b) ||
               this.isTrue(p.is_starting) || this.isTrue(p.is_captain))) continue;

          p.in_lineup = false;
          p.in_a = false;
          p.in_b = false;
          p.is_starting = false;
          p.is_captain = false;
          changed = true;
        }
        return changed;
      },
      hasBlockedPlayers: function(side) {
        var players = (this[side] && this[side].players) || [];
        for(var i = 0; i < players.length; i++) {
          if(this.isPlayerBlocked(side, i)) return true;
        }
        return false;
      },
      hasCustomPlayers(side) {
        return this[side] && this[side].customPlayers;
      },
      // The "Kapetan bo trener" shortcut. It was the third radio in the coach's seg with
      // value=missing plus a 100ms timeout that flipped the status to without_license —
      // so selecting it visibly jumped the selection to NIMA licence, and with no captain
      // chosen yet it silently did nothing and left the coach stored as missing.
      captainBecomesCoach: function(side) {
        var cap = this.captain(side);
        if(!cap) {
          alerts.warning("Najprej v postavi označi kapetana — on prevzame vlogo trenerja.");
          return;
        }
        this.setCaptainAsCoach(side);
      },
      setCaptainAsCoach: function(side) {
        var cap = this.captain(side);
        if(cap) {
          refreshContext();
          setContext(side+".coach.first_name", cap.first_name)
          setContext(side+".coach.last_name", cap.last_name)
          setContext(side+".coach.status", "without_license")
          // Which player this is, not just his name. One person then has two
          // accounts on the sheet — fouls as a player, C/B marks as coach — and the
          // rules eject him on combinations that mix them, which cannot be counted
          // without knowing they are the same person. Match#linked_coach_player_id
          // verifies it again before the live sheet trusts it.
          setContext(side+".coach.player_fms_id", cap.fms_id)
          refreshContext();
        }
      },
      shouldPersonSign: function(side, role) {
        var p = this.person(side, role);
        return ( (['home', 'away'].indexOf(side) >= 0 && role == 'coach') || side == 'assistant_referees' || side == 'referees' ) && p && p.sig && !this.hasPersonSigned(side, role);
      },
      hasPersonSigned: function(side, role) {
        var p = this.person(side, role);
        return p && p.sig && p.sig.status == 'SIGNED';
      },
      personSignedText: function(side, role) {
        if(this.hasPersonSigned(side, role)) {
          return "PODPISANO";
        } else {
          return "ČAKA NA PODPIS";
        }
      },
      arePlayersLoading(side) {
        return this[side] && this[side].playersLoading && ((this[side].players || []).filter( obj => (obj.first_name || '').length > 0 && (obj.last_name || '').length > 0 )).length == 0;
      },
      hasPlayersLoaded(side) {
        if(!this[side] || !this[side].players || this[side].players.length == 0) {
          return false;
        }
        var hasPlayers = this[side].customPlayers;
        for(let p of this[side].players) {
          hasPlayers = hasPlayers || (p.last_name && p.last_name.length > 0); 
        }
        return hasPlayers;
      },
      hasPhoto: function(side, role) {
        return this.hasPersonLicense(side, role) && getData(side+"."+role+".photo", preMatch.data);
      },
      personPhotoTag: function(side, role, klass) {
        return "<img src='"+this.personPhotoSrc(side, role)+"' class="+(klass || '')+" />";
      },
      personPhotoSrc: function(side, role) {
        var photo = getData( side+"."+role+".photo", preMatch.data );
        return 'data:image/png;base64,'+photo;
      },
      showPhoto: function(side, role) {
        var photo = getData( side+"."+role+".photo", preMatch.data );
        if(photo) {
          var obj = getContext(side+"."+role);
          alerts.info(obj.first_name + " " + obj.last_name, "<p class='text-center'>"+this.personPhotoTag(side, role)+"</p>" );
        }
      },
      canShowQrCode: function(side, role) {
        var p = this.person(side, role);
        return p && p.sig;
      },
      showQrCode: function(side, role) {
        if(this.canShowQrCode(side, role)) {
          var person = this[side][role];
          // pushes to the paired phone when there is one; the modal always
          // carries the QR code too (see signing.js)
          signing.request({ name: person.first_name + " " + person.last_name, uuid: person.sig.uuid }, preMatch.data.urls.signature);
        }
      },
      // The coach read the brief and pressed "Nekaj ni v redu".
      //
      // Confirming the bench is what locked the roster, so the refusal has to
      // unlock it — otherwise the keeper is left with a frozen sheet and a coach
      // who will not sign it, and the only way out is to guess that "Spremeni"
      // is the answer. Everything entered stays; this is exactly what pressing
      // Spremeni does, without the dialog.
      //
      // The server has already done the same to the stored document
      // (signatures#cancel). This page owns `settings` and PUTs it whole, so it
      // has to agree before its next save, or the save would put the lock back.
      signatureCancelled: function(data) {
        var uuid = data && data.uuid;
        if(!uuid) return;

        for(var side of ['home', 'away']) {
          var coach = this[side] && this[side].coach;
          if(!coach || !coach.sig || coach.sig.uuid != uuid) continue;

          this.resetPersonAction(side, 'coach');
          this.resetPersonAction(side, 'assistant');
          this.resetPersonAction(side, 'representative');
          this.save();
          refreshContext();
          $('.modal.show').modal('hide');
          alerts.warning("<p><b>" + (this[side].coach.first_name || '') + " " + (this[side].coach.last_name || '') +
                         "</b> je podpis zavrnil.</p><p>Ekipa je spet odklenjena — popravi, kar ni v redu, in znova potrdi.</p>");
          return;
        }
      },
      confirmSigned: function(uuid, payload) {
        for(d of [ ['assistant_referees', 'scorekeeper'], ['assistant_referees', 'scorekeeper_assistant'], ['assistant_referees', 'timekeeper'], ['assistant_referees', 'timekeeper_assistant'], ['home', 'coach'], ['away', 'coach'], ['referees', 'referee1'], ['referees', 'referee2'], ['referees', 'referee3'], ['referees', 'commissioner'] ]) {
          var side = d[0];
          var role = d[1];
          if(this[side] && this[side][role] && this[side][role].sig && this[side][role].sig.uuid == uuid) {
            // a coach who signed also declared the starting five; save() PUTs
            // this page's whole settings document, so apply it here first or
            // the save would undo what the server just wrote
            this.applyStartingFive(side, payload);
            this.save();
            var $modal = $('.modal.show');
            if($modal.length > 0) {
              if($modal.find('#'+uuid).length > 0) {
                $modal.modal('hide');
              }
            }
            return;
          }
        }
      },
      // The last thing the keeper reads before the entry lists are frozen, so it lists what
      // is about to be frozen: both line-ups, from the live context rather than from a
      // data-confirm string built when the page loaded.
      lineupSummary: function(side) {
        var abGroups = preMatch.data.abGroups;
        var starters = [], others = [];

        var entry = function(con, i) {
          var line = "<span class='lineups__num'>" + con.playerNumber(side, i) + "</span> "
                     + con.playerName(side, i);
          if(con.isTrue(con[side].players[i].is_captain)) line += " ©";
          // the categories that field two groups need the letter on the player: it is
          // the only place the summary can keep it
          if(abGroups) {
            if(con.isPlayerInA(side, i)) line += " <span class='lineups__group'>A</span>";
            if(con.isPlayerInB(side, i)) line += " <span class='lineups__group'>B</span>";
          }
          return line;
        };

        for(var i = 0; i < this[side].players.length; i++) {
          var onSheet = abGroups ? (this.isPlayerInA(side, i) || this.isPlayerInB(side, i))
                                 : this.isPlayerInLineup(side, i);
          if(!onSheet) continue;

          if(this.isPlayerStarting(side, i)) starters.push(entry(this, i)); else others.push(entry(this, i));
        }

        var bench = [];
        for(var role of ['coach', 'assistant', 'representative']) {
          if(!this.isPersonMissing(side, role)) bench.push(this.personName(side, role));
        }

        // No labels: the starting group is bold, the rest of the squad follows, and the
        // bench is after a rule. Read down the column against the paper list.
        // (The team name comes from the view — the settings blob carries none.)
        var html = "<div class='lineups__team'>";
        html += "<p class='lineups__name'>" + preMatch.data.teamNames[side] + "</p>";
        html += "<ul class='lineups__list'>";
        for(var st of starters) html += "<li class='is-starting'>" + st + "</li>";
        for(var ot of others) html += "<li>" + ot + "</li>";
        for(var b = 0; b < bench.length; b++) {
          html += "<li class='lineups__staff" + (b === 0 ? " is-first" : "") + "'>" + bench[b] + "</li>";
        }
        html += "</ul></div>";
        return html;
      },
      // A number typed and nobody ticked: the keeper wrote the player down and never
      // put him ON the sheet. Tekma 31362 (19. 9. 2026) was played that way — the
      // sixth man of group A had his number and no tick, so the sheet never had a row
      // for him and his six points were written on a team-mate.
      //
      // The number is the statement of intent — a player nobody means to field is
      // left without one — so this asks about exactly that gap, and reads the tick as
      // the whole of it: in_lineup on an ordinary match, A or B on one played in
      // groups, and either of them wherever a document carries both.
      //
      // Blocked players are left out: their row is not even in the table (they are
      // listed under it with the reason), so there is no tick to make and no number
      // to clear.
      numberedButOffSheet: function(side) {
        var found = [];
        var players = (this[side] && this[side].players) || [];
        for(var i = 0; i < players.length; i++) {
          var p = this.player(side, i);
          if(!p || !this.canPlayerPlay(side, i)) continue;

          var number = p.number == null ? '' : String(p.number).trim();
          if(number === '') continue;
          if(this.isTrue(p.in_lineup) || this.isTrue(p.in_a) || this.isTrue(p.in_b)) continue;

          found.push({ number: number, name: this.playerName(side, i) });
        }
        return found;
      },
      // Slovenian counts one, two and more differently, and the sentence is about
      // people the keeper is looking at — so it is built rather than interpolated.
      offSheetSentence: function(n) {
        var column = preMatch.data.abGroups ? "<b>A</b> ali <b>B</b>" : "<b>Na tekmi</b>";
        if(n === 1) {
          return "Ta igralec ima vpisano številko dresa, ni pa obkljukan v stolpcu " + column
               + " — na zapisniku ga ne bo.";
        }
        if(n === 2) {
          return "Ta igralca imata vpisano številko dresa, nista pa obkljukana v stolpcu " + column
               + " — na zapisniku ju ne bo.";
        }
        return "Ti igralci imajo vpisano številko dresa, niso pa obkljukani v stolpcu " + column
             + " — na zapisniku jih ne bo.";
      },
      offSheetWarning: function() {
        var rows = [], total = 0;
        for(var side of ['home', 'away']) {
          var list = this.numberedButOffSheet(side);
          if(!list.length) continue;

          total += list.length;
          var names = list.map(function(p) {
            return "<b><span class='lineups__num'>" + p.number + "</span> " + p.name + "</b>";
          }).join(', ');
          rows.push("<li>" + preMatch.data.teamNames[side] + ": " + names + "</li>");
        }
        if(!total) return "";

        return "<div class='lineups__warn'>"
             + "<p class='lineups__warn-title'><i class='fas fa-exclamation-triangle'></i> "
             + "Številka dresa brez mesta na zapisniku</p>"
             + "<ul class='lineups__warn-list'>" + rows.join('') + "</ul>"
             + "<p class='lineups__warn-why'>" + this.offSheetSentence(total)
             + " Obkljukaj, kdor bo igral; komur številka ne pripada, jo pobriši.</p>"
             + "</div>";
      },
      // A group that cannot field a starting line-up. Until oct 2026 this refused
      // the sheet outright (Match#settings_errors), so a club that turned up with
      // nine players for a U14 match could not be written down at all; it is a
      // warning now, said both in the rail and here, because this dialog is the
      // last thing read before the lists are frozen.
      shortGroups: function(side) {
        if(!preMatch.data.abGroups) return [];

        var size = preMatch.data.startingGroupSize, short = [];
        if(this.numberOfPlayersInA(side) < size) short.push('A');
        if(this.numberOfPlayersInB(side) < size) short.push('B');
        return short;
      },
      shortGroupWarning: function() {
        var rows = [];
        for(var side of ['home', 'away']) {
          var short = this.shortGroups(side);
          if(!short.length) continue;

          var which = short.length === 2 ? "<b>A</b> in <b>B</b>" : "<b>" + short[0] + "</b>";
          rows.push("<li>" + preMatch.data.teamNames[side] + ": " + which + "</li>");
        }
        if(!rows.length) return "";

        // four and five count differently, and so does the verb beside them
        var size = preMatch.data.startingGroupSize;
        var rule = size === 4 ? "morajo biti vsaj 4 igralci" : "mora biti vsaj " + size + " igralcev";

        return "<div class='lineups__warn'>"
             + "<p class='lineups__warn-title'><i class='fas fa-exclamation-triangle'></i> "
             + "Skupina brez cele postave</p>"
             + "<ul class='lineups__warn-list'>" + rows.join('') + "</ul>"
             + "<p class='lineups__warn-why'>V vsaki skupini " + rule
             + ". Zapisnik se kljub temu lahko odpre — kako razdeliti kratko ekipo, "
             + "odločijo sodniki in trenerja.</p>"
             + "</div>";
      },
      openSheet: function() {
        var body = "<p><b>Odpri zapisnik?</b></p>"
                 + "<p>Preberi obe postavi in ju primerjaj s prijavnima listama. "
                 + "Po tem prijavnih list ni več mogoče spreminjati.</p>"
                 + this.offSheetWarning()
                 + this.shortGroupWarning()
                 + "<div class='lineups'>"
                 + this.lineupSummary('home')
                 + this.lineupSummary('away')
                 + "</div>";

        alerts.confirmation({
          title: "Potrditev",
          body: body,
          modalClass: 'confirm-lineups',
          yesLabel: "ODPRI ZAPISNIK",
          noLabel: "NE ŠE",
          yesCallback: function() { $('#open-sheet-form').submit(); }
        });
      },
      applyStartingFive: function(side, payload) {
        var ids = payload && payload.starting_five;
        if(!ids || !this[side] || !this[side].players) return;

        ids = ids.map(String);
        for(var p of this[side].players) {
          p.is_starting = ids.indexOf(String(p.fms_id)) >= 0;
        }
        refreshContext();
      },
      // The roster's copy is older than PreMatchRoster::MAX_AGE. A match can be
      // opened days ahead and the roster used to be fetched once and never again,
      // so a player registered in the meantime was missing from the list with no
      // way to add him.
      //
      // Both sides of the subtraction come from the SERVER's clock — the stamp the
      // roster arrived with, and the clock at page render — because a browser with
      // a skewed clock would otherwise call the roster fresh forever.
      isRosterStale: function(side) {
        if(!preMatch.data.serverNow) return false;

        var loadedAt = this[side].playersLoadedAt;
        if(!loadedAt) return true;

        var age = Date.parse(preMatch.data.serverNow) - Date.parse(loadedAt);
        return !(age >= 0) || age > preMatch.data.rosterMaxAgeMs;
      },
      loadPlayers: function(side) {
        var con = this;
        // A confirmed bench locks the roster: the coach has signed for exactly this
        // list, so it must not change underneath his signature. Refreshing resumes
        // if the bench is unlocked.
        // A custom match has no FMS roster — its players are typed by hand, so there
        // is nothing to refresh and a refetch would only offer blank placeholders.
        // A played match keeps the roster it was played with — refetching would add
        // players who were never on that sheet.
        var refresh = !preMatch.data.isCustom && !preMatch.data.matchFinished &&
                      con.hasPlayersLoaded(side) && con.isRosterStale(side) && !con.isRosterLocked(side);

        if(!con.hasPlayersLoaded(side) || refresh) {
          con[side].playersLoading = true;
          refreshContext();
          ajaxLoad(preMatch.data.urls[side], function(result) {
            con[side].customPlayers = result.custom;
            con[side].players = refresh ? con.mergeRoster(con[side].players, result.data) : result.data;
            con[side].playersLoadedAt = result.loaded_at;
            var cleared = con.clearBlockedFromSheet(side);
            preloadImages( con.playerPhotos(side) );
            refreshContext();
            // Persist the merge AND the new stamp. Without this the stamp lives only
            // in the page and every visit refetches; the prematch already saves on
            // every keystroke, so one more PUT is not a change in kind.
            if(refresh || cleared) con.save();
          }, function() { con[side].playersLoading = false; refreshContext(); });
        } else {
          preloadImages( con.playerPhotos(side) );
        }
      },
      // A refresh must not undo the keeper's work, and must not move anybody: the
      // whole prematch form is bound by INDEX (`home.players[3].number`), so
      // reordering the list would rearrange what is on screen under the cursor.
      //
      // So each existing slot keeps its position and everything the keeper owns —
      // the number, who is on the sheet, the groups, the starting five, the captain
      // — and takes only the identity fields from FMS, which is where a corrected
      // name or a new licence number comes from. Players FMS no longer returns are
      // KEPT: one may already be in the line-up, and dropping him would shift every
      // index after him. Newcomers are appended, which is what this is all for.
      mergeRoster: function(existing, incoming) {
        var IDENTITY = ['first_name', 'last_name', 'license_number', 'photo_url',
                        'home_grown', 'birthdate',
                        // eligibility is the whole reason an hour-old roster is worth
                        // refetching: a player can be rested out between visits
                        'can_play', 'cannot_play_reason', 'cannot_play_custom_reason',
                        'cannot_play_text'];
        var byId = {};
        for(var inc of (incoming || [])) byId[String(inc.fms_id)] = inc;

        var merged = [];
        var seen = {};
        for(var slot of (existing || [])) {
          var fresh = byId[String(slot.fms_id)];
          if(fresh) {
            for(var key of IDENTITY) {
              if(fresh[key] !== undefined) slot[key] = fresh[key];
            }
            seen[String(slot.fms_id)] = true;
          }
          merged.push(slot);
        }
        for(var inc2 of (incoming || [])) {
          if(!seen[String(inc2.fms_id)]) merged.push(inc2);
        }
        return merged;
      },
      updateColors: function() {
        preMatch.updateColors($.extend({}, preMatch.data.home.defaultColor, this.home.color || {}), $.extend({}, preMatch.data.away.defaultColor, this.away.color || {}));
      },
      save: function(successCallback) {
        if(context.saving) {
          context.saveOnSuccess = true;
          return
        }
        context.saving = true;
        var con = context;
        $.ajax(preMatch.data.urls.save, {
          method: 'PUT',
          data: {
            save_only: 'save_only',
            "match[settings]": con.json()
          },
          success: function(data) {
            data.settings.home.players = context.home.players;
            data.settings.home.customPlayers = context.home.customPlayers;
            data.settings.home.playersLoading = context.home.playersLoading;
            data.settings.away.players = context.away.players;
            data.settings.away.playersLoading = context.away.playersLoading;
            data.settings.away.customPlayers = context.away.customPlayers;
            $.extend(context, data.settings);
            preMatch.applyPrematchState(data.prematch);
            con.saving = false;
            if(con.saveOnSuccess) {
              con.saveOnSuccess = false;
              con.save();
            }
            refreshContext();
            if(successCallback) {
              successCallback();
            }
          },
          error: function(xhr, ajaxOptions, thrownError) {
            if(xhr.status == 403) {
              alerts.warning("<h5>Tekma je bila dodeljena drugemu pomožnemu sodniku, zato nimate več pravic za urejanje tekme!</h5><p><small>Čez nekaj sekund boste avtomatasko preusmerjeni na stran s tekmami!</small></p>");
              setTimeout(function() { window.location = "/" }, 10000);
            }
          },
          complete: function() {
            con.saving = false;
          }
        });
      }
    };

    $.ajax(preMatch.data.urls.edit, {
      success: function(data) {
        if(data.redirectUrl) {
          window.location = data.redirectUrl; 
        } else {
          preMatch.initAfterLoad(data.settings);
          setContext("loaded", true);
          refreshContext();
        }
      }
    })
  },
  initAfterLoad: function(settings) {
    preMatch.initLicenseInputs();

    if(preMatch.data.isCustom && settings) {
      for(type of ['home', 'away']) {
        if(settings[type] && settings[type].players) {
          settings[type].players = settings[type].players.sort(function(a,b) { return a.fms_id < b.fms_id ? -1 : 1; }  )
        }
      }
    }
    context = $.extend(context, settings, { saving: false });


    // if empty get from ajax
    // if(!context.referees) {
    //   preMatch.loadReferees();
    // }

    context.loadPlayers('home');
    context.loadPlayers('away');

    // if(!context.hasPlayersLoaded('home')) {
    //   context.home.playersLoading = true;
    //   ajaxLoad(preMatch.data.urls.home, function(result) { context.home.customPlayers = result.custom; context.home.players = result.data; preloadImages( context.playerPhotos('home') ); refreshContext(); }, function() { context.home.playersLoading = false; refreshContext(); });
    // } else {
    //   preloadImages( context.playerPhotos('home') );
    // }

    // if(!context.hasPlayersLoaded('away')) {
    //   context.away.playersLoading = true;
    //   ajaxLoad(preMatch.data.urls.away, function(result) { context.away.customPlayers = result.custom; context.away.players = result.data; preloadImages( context.playerPhotos('away') );refreshContext(); }, function() { context.away.playersLoading = false; refreshContext(); });
    // } else {
    //   preloadImages( context.playerPhotos('away') );
    // }

    preMatch.updatePinFields();
    context.updateColors();

    $('select.colorpicker').simplecolorpicker({picker: true, theme: 'fontawesome'}).on('change', function() {
      var value = $(this).val();
      setContext($(this).data('type') + ".color." + $(this).data('colortype'), value);

      context.updateColors();
    });

    // setInterval(context.save, 20*1000); // autosave every 20s
  },
  loadReferees: function(type) {
    var url = preMatch.data.urls.referees + (type ? "?type="+type : "")
    ajaxLoad(url, function(result) { context.referees = $.extend(context.referees || {}, result.data); refreshContext(); });
  },
  // Kaj je še treba urediti, na novo s strežnika.
  //
  // Ta seznam in oznake na karticah so bili prej izrisani enkrat ob nalaganju, zato
  // je rdeče opozorilo ostalo tudi potem, ko je zapisnikar polje že izpolnil —
  // izginilo je šele ob ponovnem nalaganju strani. Pravila so v Match#settings_errors
  // in tam ostanejo; sem pride izrisan HTML, ki ga samo zamenjamo.
  //
  // Twine je treba po zamenjavi vezati znova, ker sta v tem HTML dve vezavi
  // (json() na skritem polju in openSheet na gumbu) — enako kot pri tabeli
  // tehničnih napak v poročilu.
  applyPrematchState: function(state) {
    if(!state) return;

    if(state.checklist !== undefined) $('#rail-check').html(state.checklist);
    if(state.heads) {
      for(var anchor in state.heads) $('#head-' + anchor).html(state.heads[anchor]);
    }
    if(state.flagged) {
      for(var id in state.flagged) $('#' + id).toggleClass('is-flagged', !!state.flagged[id]);
    }
    Twine.reset(context).bind().refresh();
  },
  initLicenseInputs: function() {
    $('.license-field').each(function() {
      var $input = $(this);
      var data = $input.data();

      $input.pincodeInput({inputs: data.n, hidedigits: false, complete: function(value) {
        context.syncField(data.field, value);
      }});

      if($input.hasClass('form-control-sm')) {
        $input.parent().find('.pincode-input-text').addClass('form-control-sm');
      }
    });
  },
  // Tick the radio the way a keeper would, rather than only writing the value.
  // On a match nobody has touched, settings carries no entry for this official at
  // all, and Twine binds each box to the object it resolved when the page loaded —
  // so writing the status into a path that did not exist leaves the box inert. The
  // radio's own two-way binding is what brings it to life, and clicking it is
  // exactly what the keeper does by hand.
  selectPersonStatus: function(side, role, status) {
    var $radio = $('.person-with-license[data-side="'+side+'"][data-role="'+role+'"]')
                   .find('input[type=radio][value="'+status+'"]');
    if($radio.length) {
      $radio.prop('checked', true).trigger('click').trigger('change');
    }
    setContext(side+"."+role+".status", status);
  },

  // The licence input is a pincodeInput — a row of single-character boxes — so
  // setting the context value alone leaves the boxes empty and the keeper cannot
  // see the number that is about to be checked.
  fillPinField: function(side, role, number) {
    var $person = $('.person-with-license[data-side="'+side+'"][data-role="'+role+'"]');
    var digits = String(number);
    $person.find('.pincode-input-text').each(function(i) {
      $(this).val(digits.charAt(i) || '');
    });
  },

  // Which licence register a side is checked against.
  licenseTypeFor: function(side) {
    if(side == 'assistant_referees') return 'assistant_referee';
    if(side == 'statisticians') return 'statistician';
    return 'coach';
  },

  updatePinFields: function() {
    $('.person-with-license').each(function() {    
      var $self = $(this);
      var side = $self.data('side');
      var role = $self.data('role');

      var i = 0;
      if(context[side] && context[side][role]) {
        var lic = context[side][role].checked_number;
        var has_license = context[side][role].status == "with_license";
        if(lic && has_license) {
          $self.find('.pincode-input-text').each(function() {
            $(this).val( lic.charAt(i++) );
          });

          preMatch.validatePerson(side, role, lic, preMatch.licenseTypeFor(side));
        }
      }
    });
  },
  updateColors: function(home, away) {
    $('.colorpicker[data-type=home][data-colortype=bg]').val(home.bg);
    $('.colorpicker[data-type=home][data-colortype=text]').val(home.text);
    $('.colorpicker[data-type=away][data-colortype=bg]').val(away.bg);
    $('.colorpicker[data-type=away][data-colortype=text]').val(away.text);

    var $style = $('style#colors');
    var html = ".home-team { color: "+home.text+"; background-color: "+home.bg+"; }";
    html += ".home-jersey { color: "+home.text+"; fill: "+home.bg+";}"

    html += ".away-team { color: "+away.text+"; background-color: "+away.bg+"; }";
    html += ".away-jersey { color: "+away.text+"; fill: "+away.bg+";}"

    $style.html(html);
  },
  // Confirming without the "are you sure" dialog, because the pick WAS the answer.
  //
  // The save creates the signature slot; the server is then asked whether this
  // person has a signature to carry over from the match they last signed. If they
  // do, it is applied and the pad is not opened — the badge simply says signed. If
  // they do not, which is the ordinary case for somebody new, the pad opens exactly
  // as it always did.
  settlePerson: function(side, role) {
    if(!context.canConfirmPerson(side, role)) return;

    setContext(side + "." + role + ".confirmed", "confirmed");
    context.save(function() {
      if(context.isPersonMissing(side, role)) return;
      preMatch.reuseSignature(side, role, function(reused) {
        if(!reused) context.showQrCode(side, role);
      });
    });
  },

  reuseSignature: function(side, role, done) {
    if(!preMatch.data.urls.signatureReuse) return done(false);

    $.ajax(preMatch.data.urls.signatureReuse, {
      method: 'POST',
      data: { side: side, role: role },
      success: function(data) {
        if(data && data.reused) {
          setContext(side+"."+role+".sig", { uuid: data.uuid, status: data.signature_status });
        }
        done(!!(data && data.reused));
      },
      // the pad is the way this always worked, so a failure falls back to it
      error: function() { done(false); }
    });
  },

  // A check that did not produce an answer must leave nothing behind that looks
  // like one. Anything still on screen would be attributed to the number in the
  // field, which is exactly the number nobody managed to verify.
  clearLicenseVerdict: function(side, role) {
    preMatch.data.confirmAfterCheck = null;
    setContext(side+"."+role+".first_name", "");
    setContext(side+"."+role+".last_name", "");
    setContext(side+"."+role+".license_status", "");
    setContext(side+"."+role+".license_status_code", "");
    setContext(side+"."+role+".checked_number", "");
  },

  // The register could not be asked. That is not the same as "this number is
  // unknown", so the keeper stays where they are — switching them to NIMA licence
  // would record a licensed official as unlicensed because of a network blip.
  // They cannot confirm without a name, so the way out is named out loud.
  licenseCheckUnavailable: function(side, role, msg) {
    preMatch.clearLicenseVerdict(side, role);
    alerts.warning((msg || 'Licence ni bilo mogoče preveriti.') +
      "<p></p><p>Poskusi znova. Če registra še vedno ni mogoče doseči, izberi <b>NIMA licence</b> in vpiši ime in priimek, da se tekma lahko začne.</p>");
  },

  validatePerson: function(side, role, number, type) {
    setContext(side+"."+role+".checking", true);
    $.ajax(preMatch.data.urls.validations, {
      data: { 
        type: type,
        number: number,
        competition_id: preMatch.data.competition_id,
        match_id: preMatch.data.match_id,
        side: side
      },
      success: function(data) {
        if(data.status != 'OK') {
          // the endpoint refused the request itself; there is no verdict to show
          preMatch.licenseCheckUnavailable(side, role);
          return;
        }
        {
          var d = data.data;
          if(d.status_code == 'REGISTER_UNAVAILABLE') {
            preMatch.licenseCheckUnavailable(side, role, d.msg);
            return;
          } else if(d.status_code == 'OK') {
            setContext(side+"."+role+".first_name", d.object.firstname);
            setContext(side+"."+role+".last_name", d.object.lastname);
            if(preMatch.data.confirmAfterCheck == side + "." + role) {
              setContext(side+"."+role+".checked_number", number);
              preMatch.settlePerson(side, role);
            }
          } else if(d.status_code == 'NO_LICENSE') {
            // The number is not in the register, so there is no licence for a name
            // to hang on. Put the keeper where a name may be typed instead of
            // telling them to go there, and hand back whatever they had typed
            // before they switched.
            var typed = getData(side+"."+role+".typed", preMatch.data) || {};
            preMatch.selectPersonStatus(side, role, 'without_license');
            setContext(side+"."+role+".first_name", typed.first_name || "");
            setContext(side+"."+role+".last_name", typed.last_name || "");
            alerts.warning(d.msg + "<p></p><p>Prestavili smo na <b>NIMA licence</b>. Če ste se pri številki zmotili, izberite <b>IMA licenco</b> in jo vnesite znova; sicer vpišite ime in priimek.</p>");
          } else if(d.status_code == 'INSUFFICIENT_LICENSE_LEVEL') {
            alerts.warning(d.msg);
            setContext(side+"."+role+".first_name", d.object.firstname);
            setContext(side+"."+role+".last_name", d.object.lastname);
          }
          setContext(side+"."+role+".license_status", d.status);
          // WHY the verdict is what it is, not only that it is a warning. The two
          // reasons a check can refuse — the number is not in the register, or the
          // licence is not good enough for this match — look identical in
          // license_status, and the commissioner reading the match in FMS is
          // exactly the person who needs them apart (MatchLicenses#reason_of).
          setContext(side+"."+role+".license_status_code", d.status_code);
          setContext(side+"."+role+".checked_number", number);

          // cache photo
          setData(side+"."+role+".photo", d.object ? d.object.photo : null, preMatch.data);
        }
      },
      // there was no error handler at all: a 500 stopped the spinner and said
      // nothing, leaving the previous check's green verdict standing under a
      // different number
      error: function() {
        preMatch.licenseCheckUnavailable(side, role);
      },
      complete: function() {
        setContext(side+"."+role+".checking", false);
      }
    });
  },
  validateCoach: function(side, role, number) {
    preMatch.validatePerson(side, role, number, 'coach');
  },
  validateAssistantReferee: function(side, role, number) {
    preMatch.validatePerson(side, role, number, 'assistant_referee');
  },
  validateStatistician: function(side, role, number) {
    preMatch.validatePerson(side, role, number, 'statistician');
  }
}
